import { combinedApi as api } from "../combinedApi";
export const addTagTypes = ["DeviceModel"] as const;
const injectedRtkApi = api
  .enhanceEndpoints({
    addTagTypes,
  })
  .injectEndpoints({
    endpoints: (build) => ({
      getDeviceModel: build.query<
        GetDeviceModelApiResponse,
        GetDeviceModelApiArg
      >({
        query: () => ({ url: `/DeviceModel` }),
        providesTags: ["DeviceModel"],
      }),
      postDeviceModel: build.mutation<
        PostDeviceModelApiResponse,
        PostDeviceModelApiArg
      >({
        query: (queryArg) => ({
          url: `/DeviceModel`,
          method: "POST",
          body: queryArg,
        }),
        invalidatesTags: ["DeviceModel"],
      }),
      putDeviceModelById: build.mutation<
        PutDeviceModelByIdApiResponse,
        PutDeviceModelByIdApiArg
      >({
        query: (queryArg) => ({
          url: `/DeviceModel/${queryArg.id}`,
          method: "PUT",
          body: queryArg.deviceModelDto,
        }),
        invalidatesTags: ["DeviceModel"],
      }),
      deleteDeviceModelById: build.mutation<
        DeleteDeviceModelByIdApiResponse,
        DeleteDeviceModelByIdApiArg
      >({
        query: (queryArg) => ({
          url: `/DeviceModel/${queryArg}`,
          method: "DELETE",
        }),
        invalidatesTags: ["DeviceModel"],
      }),
    }),
    overrideExisting: false,
  });
export { injectedRtkApi as deviceModelApi };
export type GetDeviceModelApiResponse = /** status 200 OK */ DeviceModelDto[];
export type GetDeviceModelApiArg = void;
export type PostDeviceModelApiResponse = /** status 201 Created */ void;
export type PostDeviceModelApiArg = DeviceModelDto;
export type PutDeviceModelByIdApiResponse = /** status 200 OK */ void;
export type PutDeviceModelByIdApiArg = {
  id: number;
  deviceModelDto: DeviceModelDto;
};
export type DeleteDeviceModelByIdApiResponse = unknown;
export type DeleteDeviceModelByIdApiArg = number;
export type DeviceModelDto = {
  id: number;
  name?: string | null;
  manufacturer?: string | null;
  comment?: string | null;
  isUsed: boolean;
  noiseThresholdCurrent?: number | null;
  noiseThresholdVoltage?: number | null;
};
export type ProblemDetails = {
  type?: string | null;
  title?: string | null;
  status?: number | null;
  detail?: string | null;
  instance?: string | null;
  [key: string]: any;
};
export const {
  useGetDeviceModelQuery,
  useLazyGetDeviceModelQuery,
  usePostDeviceModelMutation,
  usePutDeviceModelByIdMutation,
  useDeleteDeviceModelByIdMutation,
} = injectedRtkApi;
